export const apiUrl = process.env.REACT_APP_CARDVESTURL
// export const apiUrl = "https://staging.cardvest.ng/api/v2/";
// export const apiUrl = "https://api.cardvest.ng/api/v2/";
